<template>
    <div >
      <b-row>
          <b-col md="12">
                <MdTitle v-bind:Text="$t('ItemAvailabilityRep.ReportTitle')" />
          </b-col>
      </b-row>
      <b-row>
          <div class="col-sm-12 col-md-12 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                  <div class="input-group"  dir="ltr">
                      <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                          @keyup.enter="LoadItemAva" />

                      <div class="input-group-append">
                          <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'" v-on:click="LoadItemAva">
                          </MdButton>
                      </div>
                  </div>
              </div>
          </div>
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('Medication.Drugs')"
              v-bind:Options="DrugList"
              v-bind:Model="DrugsCodeModel"
              v-bind:FieldDescription="'drugname'"
              v-bind:FieldCode="'drugCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('ItemExpFiltersRep.LotNo')"
                v-bind:TypeProp="'text'" 
                v-bind:Name="'lots'"
                v-model="lots"
                >                                     
              </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">
             <MdSelect
              v-bind:Label="$t('Shared.Type')"
              v-bind:Options="typeOptions"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:ModelArray="type"  
              :Input="ChangeType"/>
          </b-col>
          <b-col lg="6" md="6" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadItemAva"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

           <div class="row">
                <div class="col-md-12">
                  <MdTable  v-if="tableMode === 'SUMMARY' || tableMode === 'SUMMARYEND'"
                    :key="'SUMMARY'"
                    v-bind:fields="summaryFields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    >
                  </MdTable>
                </div>

                <div class="col-md-12">
                  <MdTable  v-if="tableMode === 'DETAIL'"
                    :key="'DETAIL'"
                    :fields="detailFields"
                    :items="items"
                    :totalRows="totalRows"
                    :showMessageIsEmpty="ShowMessageIsEmpty"
                    :currentPage="currentPage"
                    :perPage="perPage"
                    :pageOptions="pageOptions"
                    :refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                  />
                </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="ReportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportItemAvailabilityFilters"
          :ReportName="ReportName"
          :ReportTitle="ReportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="ReportTitle"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/ItemAvailability/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import { EventBus } from '@/event-bus.js';
  import UtilsService from '@/services/utils.service'
  import Utils from "@/common/utils";
  
  export default Vue.extend({
      name: "ItemAvailabilityRep",
      mixins: [ ShowMessage, PharmacyRepFunctions, DBFunctions ],
      components: { DxPopup },
      data() {
          return {
              ReportName: 'ItemAvailability',
              ReportTitle: this.$t('ItemAvailabilityRep.ReportDTitle'),
              isParamVisible: true,
              isReportVisible: false,
              reportParams: [],
              DrugList:[],
              DrugsCodeModel:'',
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                DrugType: '',
                LocList: ''
              },
              DrugTypeModel: '',
              DrugTypeList: [],
              lots: '',
              typeOptions: [
                { value: 'DETAIL', text: this.$t('dailyServiceCharge.Detail') },
                { value: 'SUMMARY', text: this.$t('dailyServiceCharge.Summary') },
                { value: 'SUMMARYEND', text: this.$t('ItemAvailabilityRep.SummaryEndo') }
              ],
              type: null,
              tableMode: 'DETAIL',
              items: [],
               // ===== COLUMAS SUMMARY =====
              summaryFields: [
                { key: 'ItemCode', sortable: true, label: this.$t('ItemAvailabilityRep.ItemCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('drug.Drugname'), class: 'text-left' },
                { key: 'QTYAvailable', sortable: true, label: this.$t('ItemAvailabilityRep.QTYAvailable'), class: 'text-left' },
                { key: 'Location', sortable: true, label: this.$t('ItemAvailabilityRep.Location'), class: 'text-left' }
              ],         
              detailFields: [
                { key: 'DateReceived', sortable: true, label: this.$t('ItemAvailabilityRep.DateReceived'), class: 'text-center' },
                { key: 'ItemCode', sortable: true, label: this.$t('ItemAvailabilityRep.ItemCode'), class: 'text-left' },
                { key: 'ItemNo', sortable: true, label: this.$t('ItemAvailabilityRep.ItemNo'), class: 'text-left' },
                { key: 'QTYReceived', sortable: true, label: this.$t('ItemAvailabilityRep.QTYReceived'), class: 'text-left' },
                { key: 'DrugCode', sortable: true, label: this.$t('drug.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('drug.Drugname'), class: 'text-left' },
                { key: 'BatchNo', sortable: true, label: this.$t('ItemAvailabilityRep.BatchNo'), class: 'text-left' },
                { key: 'ActiveIngred', sortable: true, label: this.$t('ItemAvailabilityRep.ActiveIngred'), class: 'text-left' },
                { key: 'DrugType', sortable: true, label: this.$t('Shared.DrugType'), class: 'text-center' },
                { key: 'Controlled', sortable: true, label: this.$t('ItemAvailabilityRep.Controlled'), class: 'text-center' },
                { key: 'InQTYFilled', sortable: true, label: this.$t('ItemAvailabilityRep.InQTYFilled'), class: 'text-left' },
                { key: 'OutQTYFilled', sortable: true, label: this.$t('ItemAvailabilityRep.OutQTYFilled'), class: 'text-left' },
                { key: 'QTYFilled', sortable: true, label: this.$t('ItemAvailabilityRep.QTYFilled'), class: 'text-left' },
                { key: 'QTYAvailable', sortable: true, label: this.$t('ItemAvailabilityRep.QTYAvailable'), class: 'text-left' },
                { key: 'QTYremoved', sortable: true, label: this.$t('ItemAvailabilityRep.QTYremoved'), class: 'text-left' },
                { key: 'LotNo', sortable: true, label: this.$t('ItemAvailabilityRep.LotNo'), class: 'text-left' },
                { key: 'ExpirationDate', sortable: true, label: this.$t('ItemAvailabilityRep.ExpirationDate'), class: 'text-center' },
                { key: 'Location', sortable: true, label: this.$t('ItemAvailabilityRep.Location'), class: 'text-left' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true
          }
      },

      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },
          
          ChangeType(selected) {
            if (!selected) return
         
            this.type = selected
            this.items = []
            this.currentPage = 1
            this.tableMode = null
            this.totalRows = this.items.length;

            this.$nextTick(() => {
              switch(selected.value) {
                case 'SUMMARY':
                  this.ReportName = 'ItemAvailabilitySummary';
                  this.ReportTitle = this.$t('ItemAvailabilityRep.ReportSTitle')
                break;
                case 'SUMMARYEND':
                  this.ReportName = 'ItemAvailabilitySummaryEd';
                  this.ReportTitle = this.$t('ItemAvailabilityRep.ReportWETitle')
                break;
                default:
                  this.ReportName = 'ItemAvailability';
                  this.ReportTitle = this.$t('ItemAvailabilityRep.ReportDTitle')
              }
              this.tableMode = selected.value
            })
          },

         

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'plots', paramValue: this.lots})
            this.reportParams.push({ paramName: 'pType', paramValue: this.type.value})
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportItemAvailabilityFilters.buildDocument(this.reportParams)
          },

          LoadItemAva() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DrugType = this.params.DrugType && this.params.DrugType !== '' 
              ? this.params.DrugType
              : null;
           
            this.parameter.LocList = this.params.LocList && this.params.LocList !== '' 
              ? this.params.LocList
              : null;

            this.parameter.lots = this.lots && this.lots !== '' 
              ? this.lots
              : null;

            this.parameter.Type = this.type.value;
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_ItemsAvailability'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                Lots: this.parameter.lots,
                DrugCode: this.parameter.DrugList,
                DrugType: this.parameter.DrugType,
                Locations: this.parameter.LocList,
                Type: this.parameter.Type
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  if (response.status == "200" && response.data) {
                      this.items = response.data;
                      this.items.forEach(function(element) {
                        let { ExpirationDate, DateReceived } = element
                        if (ExpirationDate) element.ExpirationDate = Utils.formatterDateToString(ExpirationDate);
                        if (DateReceived) element.DateReceived = Utils.formatterDateToString(DateReceived);            
                      });

                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                      this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                      this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },

          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf(this.ReportName, true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf(this.ReportName, true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          getDefaultType() {
            this.type = { value: 'DETAIL', text: this.$t('dailyServiceCharge.Detail') }
          },
      },
      created() {
       
      },

      mounted () {
        this.getDefaultType();
        this.getDrugsFilter();
        this.getLocationsFilter();
        this.getDrugTypeFilter();
        
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
